import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import FormLabel from "../styledElements/label";
import InputError from "../styledElements/inputError";
import StyledDateTimePicker from "../styledElements/datePicker/StyledDateTimePicker";
import { format, getLocaleDateFormat } from "@cortexglobal/cortex-utilities";

const DateTimePickerContainer = styled.div`
    width: 100%;
    max-width: ${(props) => (props.expanded ? "100%" : "100%")};
`;

const DateTimePicker = ({
    name,
    label,
    value,
    allowEmpty,
    easyRead,
    onChange,
    ...props
}) => {
    const handleChange = (date) => {
        return onChange({ name, value: date });
    };

    return (
        <DateTimePickerContainer>
            {label && <FormLabel {...props}>{label}</FormLabel>}
            {easyRead && <b>{easyRead}</b>}
            <StyledDateTimePicker
                {...props}
                name={name}
                value={value}
                selected={value}
                onChange={handleChange}
            />

            <InputError error={props.error} />
        </DateTimePickerContainer>
    );
};

DateTimePicker.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    initialValue: PropTypes.any,
    size: PropTypes.string,
    expanded: PropTypes.bool,
    inlineLabel: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    emptyOption: PropTypes.string,
    error: PropTypes.string,
    allowEmpty: PropTypes.bool,
};
DateTimePicker.defaultProps = {
    error: "",
    expanded: true,
    dateFormat: getLocaleDateFormat() + " HH:mm",
    selected: new Date(),
    allowEmpty: false,
};
export default DateTimePicker;
